/// <amd-module name="TFS/Views/ProjectOverviewPage/Shared/Models" />

export interface ProjectOverviewPageData {
    projectBasicData: ProjectBasicData;
    currentUser: CurrentUserPermission;
}

export interface ProjectBasicData {
    id: string;
    name: string;
    description: string;
    visibility: string;
    isOrganizationActivated: boolean;
    isProjectImageSet: boolean;
    defaultTeamId: string;
}

export interface CurrentUserPermission {
    hasManageProjectPropertiesPermission: boolean;
    hasProjectLevelEditPermission: boolean;
    isStakeHolder: boolean;
    isAdmin: boolean;
    isLoggedIn: boolean;
}

export interface MembersData {
    count: number;
    hasMore: boolean;
    members: MemberInfo[];
}

export interface MemberInfo {
    id: string;
    name: string;
}
